document.addEventListener("DOMContentLoaded", function () { 
    const mediawrapp = document.querySelector(".product__media-wrapper");
    const mediaSlider = mediawrapp.querySelector(".media-main-swiper");
    const thumbSlider = mediawrapp.querySelector(".thumbnail-swiper");
    console.log("this is before");
    
    if (!mediawrapp || !mediaSlider || !thumbSlider) return;

    console.log("this is after");

    var thumbswiper = new Swiper(thumbSlider, {
        spaceBetween: 10,
        slidesPerView: 4,
        freeMode: true,
        watchSlidesProgress: true,
        480: {
            slidesPerView: 5,
            spaceBetween: 10,
        },
        768: {
            slidesPerView: 4,
            spaceBetween: 10,
        },
        990: {
            slidesPerView: 5,
            spaceBetween: 15,
        },
    });

    var mediaswiper = new Swiper(mediaSlider, {
      spaceBetween: 10,
      slidesPerView: 1,
      autoHeight: true,
      thumbs: {
        swiper: thumbswiper,
      },
    });
});